angular.module('mean.admin-panel').factory('userService', ['$filter', '$q', 'Users', 'Trades', 'Builders', 'builderService',
    function($filter, $q, Users, Trades, Builders, builderService) {

        var getUsers = function(trade, code) {
            var deferred = $q.defer();

            Users.query({'trade': trade, 'contractor_code': code}, function(users) {
                deferred.resolve(users);
            });

            return deferred.promise;
        }

        var getCompanyName = function(username) {
            var deferred = $q.defer();
            getMainAccountId(username).then(function(item) {
                if(!builderService.isBuilder(username)) {
                    Trades.query({'main_account_id': item}, function(trade) {
                        if(trade.length === 1)
                            deferred.resolve(trade[0]['trade']);
                    });
                } else {
                    Builders.query({'builder': item}, function(builder) {
                        if(builder.length === 1)
                            deferred.resolve(builder[0]['trade']);
                    });
                }
            });

            return deferred.promise;
        }

        var isAdmin = function(user) {
            var admin = false;
            for(var i=0; i<user.roles.length; i++) {
                if (user.roles[i] === 'admin') {
                    admin = true;
                }
                if (user.roles[i] === 'tm_office') {
                    admin = true;
                }
                if (user.roles[i] === 'builder_admin') {
                    admin = true;
                }
                if (user.roles[i] === 'tm_admin') {
                    admin = true;
                }
            }

            return admin;
        }

        var isOffice = function(user) {
            return user.roles.indexOf('tm_office') !== -1;
        }

        var getCompanyCode = function(username) {
            var array = username.split('', 9);
            return array[2] + array[3] + array[4];
        }

        var getTradeCode = function(username) {
            var array = username.split('', 9);
            return array[0] + array[1];
        }

        var getMainUsername = function(username) {
            var array = username.split('', 9);
            var trade = array[0] + array[1];
            var code = array[2] + array[3] + array[4];
            return trade + code + "0000";
        }

        var getMainAccountId = function(username) {
            var array = username.split('', 9);
            var trade = array[0] + array[1];
            var code = array[2] + array[3] + array[4];
            var new_val = trade + code + "0000";
            var deferred = $q.defer();

            Users.query({'username': new_val}, function(users) {
                if(users.length === 1) {
                    deferred.resolve(users[0]._id);
                }
            });

            return deferred.promise;
        }

        var getMainAccount = function(username) {
            var array = username.split('', 9);
            var trade = array[0] + array[1];
            var code = array[2] + array[3] + array[4];
            var new_val = trade + code + "0000";
            var deferred = $q.defer();

            Users.query({'username': new_val}, function(users) {
                if(users.length === 1) {
                    deferred.resolve(users[0]);
                }
            });

            return deferred.promise;
        }

        var generateId = function(users, trade, contractor_code) {
            //This is for the builder so we know the first
            //two digits of the id will be 00 since that
            //is the trade code.  And we also know that the
            //next three digits will be the company code
            //which we already have.  Now we need to figure
            //out the last number entered for this company
            //so we can increment and save.
            var largest_value = 0;
            for(var i=0; i<users.length; i++) {
                var array = users[i].username.split('', 9);
                var check = parseInt(array[5] + array[6] + array[7] + array[8]);

                if(check > largest_value)
                    largest_value = check;
            }

            //now increment largest_value for a new id
            largest_value++;

            if(largest_value > 9999)
                return null;

            largest_value = largest_value.toString();

            while(largest_value.length < 4) {
                largest_value = '0' + largest_value;
            }

            return trade + contractor_code + largest_value;
        }

        return {
            isAdmin: isAdmin,
            isOffice: isOffice,
            getCompanyName: getCompanyName,
            generateId: generateId,
            getUsers: getUsers,
            getMainUsername: getMainUsername,
            getCompanyCode: getCompanyCode,
            getTradeCode: getTradeCode,
            getMainAccountId: getMainAccountId,
            getMainAccount: getMainAccount
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/admin-panel/public/services/user-service.js